import { format } from "date-fns";
import { getValueOrDefault } from "~/lib/shared/getValueOrDefault";

const isValidDateString = (
  dateString: string | undefined | null
): dateString is string => Number.isFinite(new Date(dateString!).getTime());

export const getDateMonthShortName = (dateString: string | undefined | null) =>
  isValidDateString(dateString)
    ? Intl.DateTimeFormat("en-US", { month: "short" }).format(
        new Date(dateString)
      )
    : "";

export const getDateDayTwoDigit = (dateString: string | undefined | null) =>
  isValidDateString(dateString)
    ? Intl.DateTimeFormat("en-US", { day: "2-digit" }).format(
        new Date(dateString)
      )
    : "";

/**
 *
 * @param date Date to format
 * @param formatString formatter string to use. Defaults to MMMM d, yyyy.
 *  See https://date-fns.org/docs/format for more info
 * @returns
 */
export const safeDateFormat = (
  dateString: string | null | undefined,
  formatString?: string
) =>
  isValidDateString(dateString)
    ? format(
        new Date(dateString),
        getValueOrDefault(formatString, "MMMM d, yyyy")
      )
    : "";
